import { useEffect, useState } from 'react'

/**
 * @deprecated use css custom media queries instead
 *
 * Subscribes to the MediaQueryList itself: its `change` event fires once, when
 * the query starts or stops matching. A window `resize` listener would re-ask
 * on every event instead, and at a width right on the breakpoint (Safari sends
 * them non-stop while the window is dragged or a scrollbar appears) the answer
 * flaps, and so does everything that depends on it.
 */
const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const media = window.matchMedia(query)

    setMatches(media.matches)

    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches)

    media.addEventListener('change', onChange)

    return () => media.removeEventListener('change', onChange)
  }, [query])

  return matches
}

export default useMediaQuery
